var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 5l-.6-1.208a.836.836 0 00-.75-.458H4.999a.836.836 0 00-.833.833v12.5c0 .458.375.833.833.833a.836.836 0 00.834-.833v-5h4.166l.6 1.208a.833.833 0 00.742.459h4.492a.836.836 0 00.833-.834V5.833A.836.836 0 0015.833 5h-4.167zm3.333 6.667h-3.333L10.833 10h-5V5h4.166l.834 1.667h4.166v5z",
    fill: "#58B847"
  })));
}
export default SvgFlag;